<template>
  <div>
    <video class="video-message" controls :autoplay="autoplay" muted>
      <source :src="url">
      Your browser does not support video.
    </video>
  </div>
</template>

<script>
import { isYoungerThanSeconds } from '../../../../common/time'

export default {
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    url () {
      return this.message.content.url
    },
    autoplay () {
      return (isYoungerThanSeconds(this.message.createdAt, 10))
    }
  }
}
</script>

<style>
  .video-message {
    width: 100%;
    border-radius: 5px;
    min-height: 50px;
    min-width: 100px;
    background-color: #dcdcdc;
    outline: 0;
  }
</style>
